module.exports = __webpack_public_path__ + "img/undraw_Gift_card_re_5dyy.357037d8.svg";